import { ExtrudeGeometry, Material, Mesh, Shape } from "three";
import { mergeGeometries } from "three/examples/jsm/utils/BufferGeometryUtils";
import { Polygon } from "./types";

function shapeFromPolygon(poly: Polygon): Shape {
  const shape = new Shape();
  if (!poly || poly.length === 0) return shape;
  shape.moveTo(poly[0].x, poly[0].y);
  for (let i = 1; i < poly.length; i++) shape.lineTo(poly[i].x, poly[i].y);
  shape.closePath();
  return shape;
}

export function extrudePolygons(
  polygons: Polygon[],
  material: Material,
  depth = 0.05,
  bevelSize = 0
): Mesh {
  const geoms = polygons.map((poly) => {
    const shape = shapeFromPolygon(poly);
    const geom = new ExtrudeGeometry(shape, {
      depth,
      bevelEnabled: bevelSize > 0,
      bevelSize,
      bevelThickness: bevelSize,
      bevelOffset: -bevelSize,
      bevelSegments: 1,
    });
    geom.computeVertexNormals();
    geom.translate(0, 0, -depth / 2);
    return geom;
  });
  const merged = mergeGeometries(geoms, true);
  const geometry = merged;
  const mesh = new Mesh(geometry, material);
  mesh.castShadow = true;
  mesh.receiveShadow = true;
  return mesh;
}
